/* eslint-disable */
import Qs from 'qs';
import $ from 'jquery';

export default {
  method: 'post',
  transformRequest: [
    function (data) {
      //由于使用的form-data传数据所以要格式化
      data = Qs.stringify(data);
      return data;
    }
  ],
  data: {
  }
};
function getSecurityData () {
  var gettime = Date.parse(new Date()) / 1000;
  var u = 'icu_token_008';
  return {
  };
}



// WEBPACK FOOTER //
// ./src/api/config.js